<template>
    <div class="w100_">
        <el-select ref="diagnoseSelect" :disabled="isDisabled" v-model="diagnosIds1" placeholder=""
            allow-create default-first-option filterable remote :loading="selectLoading" multiple reserve-keyword
            :remote-method="meetDiagnose" @change="diagnosChange" value-key="name" :popper-append-to-body="false" popper-class="customSelectStyle">
            <el-option v-for="(item, index) in diagnosisList" :key="index" :label="item.name"
                :value="item">
                <div class="diagnose-warp">
                    <div> {{ item.name }}</div>
                    <div>
                        <span class="diagnose-recode">{{ item.recode }}</span>
                        <span class="diagnose-code">{{ item.code }}</span>
                    </div>
                </div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
import { meetDiagnose } from "@/api/history"; // 病历请求
export default {
  props:{
    isDisabled:{
      type:Boolean,
      default:false,
    },
    diagnosIds:{
      type:Array
    }
  },
  created () {
    
  },
  data() {
    return {
      selectLoading:false,//下拉框搜索
      diagnosisList: [],//诊断列表
      // diagnosIds: [],
      diagnosIds1:this.diagnosIds
    }
  },
  methods:{
    meetDiagnose: _.debounce(function (val) {
      if (!_.isEmpty(val)) {
        this.selectLoading=true;
        meetDiagnose({ search: val, pageNum: 1, pageSize: 30 }).then(res => {
          if (res.code == 200) {
            this.diagnosisList = res.rows
          }
          this.selectLoading=false;
        })
      }
    }, 300),
    diagnosChange(e) {
      this.$refs.diagnoseSelect.query = ''
      let arr = []
      e.forEach(item => {
        if (_.isObject(item)) {
          arr.push({
            diagnoseCode: item.code,
            diagnoseName: item.name,
          })
        } else {
          arr.push({
            diagnoseCode: '',
            diagnoseName: item,
          })
        }
      })
      this.$emit('changrDia',{list:arr,ids:this.diagnosIds1})
      console.log(' this.chooseDiagnosisList', arr,this.diagnosIds1);
     
    },
  }

}
</script>

<style lang="less" scoped>
.diagnose-warp {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .diagnose-recode {
        margin-right: 20px;
    }

    .diagnose-code {
        width: 100px;
    }
}
/deep/.el-select{
  // border: none;
  width: 100%;
}
</style>